import React from "react";
import { View } from "@/styles/reactnative";

const MarketTableHeaderLists = ({
  item,
  index,
  amountColor,
  rateColor,
}: any) => {
  return (
    <View
      style={{
        flexDirection: "row",
        justifyContent: "space-between",
        marginTop: 15,
      }}
    ></View>
  );
};

export default React.memo(MarketTableHeaderLists);
